import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "../components/Icon";
import { usePortal } from "../state/PortalContext";

export function AuthCallbackPage() {
  const { user, authLoading } = usePortal();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading && user) {
      navigate(user.role === "student" ? "/app/map" : "/faculty", {
        replace: true,
      });
    }
  }, [authLoading, navigate, user]);

  return (
    <div className="grid min-h-screen place-items-center px-5">
      <div className="text-center">
        <div className="mx-auto grid h-20 w-20 place-items-center rounded-3xl bg-indigo-500/15 text-indigo-300">
          <Icon name="Compass" size={36} className="animate-spin" />
        </div>
        <h1 className="mt-6 font-display text-3xl font-bold text-white">
          Opening the portal
        </h1>
        <p className="mt-2 text-sm text-slate-400">
          Verifying your secure sign-in link...
        </p>
      </div>
    </div>
  );
}
